import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useGet } from "../../customHooks/useGet";
import { usePut } from "../../customHooks/usePut";
import { FaSave, FaTimesCircle } from "react-icons/fa";

const API_BASE_URL = "https://ectech-software.com.ar/api/core/users";

function UserEdit({ user, setShowForm, refetch }) {
  const { data: userData, loading, error } = useGet(`${API_BASE_URL}/${user.id}`);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    postalCode: "",
    locality: { id: 1 },
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { executePut } = usePut();

  useEffect(() => {
    if (userData && userData.userData) {
      setFormData({
        firstName: userData.userData.name || "",
        lastName: userData.userData.lastname || "",
        email: userData.userData.email || "",
        phone: userData.userData.telephone || "",
        address: userData.userData.address || "",
        postalCode: userData.userData.postalCode || "",
        locality: { id: userData.userData.locality?.id || 1 },
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "El nombre es obligatorio.";
    if (!formData.lastName.trim()) newErrors.lastName = "El apellido es obligatorio.";
    if (!formData.email) newErrors.email = "El correo es obligatorio.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);

    try {
      const formattedData = {
        username: user.username,
        password: user.password,
        status: true,
        userData: {
          name: formData.firstName,
          lastname: formData.lastName,
          email: formData.email,
          telephone: formData.phone,
          address: formData.address,
          postalCode: formData.postalCode,
          locality: { id: formData.locality.id },
        },
      };

      await executePut(`${API_BASE_URL}/${user.id}`, formattedData);
      alert("Usuario actualizado con éxito.");
      refetch(); // Llama a refetch para actualizar la tabla
      setShowForm(false); // Cierra el formulario
    } catch (error) {
      console.error("Error al actualizar el usuario:", error);
      alert(`Error al actualizar el usuario: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <p className="text-center">Cargando...</p>;
  if (error) return <p className="alert alert-danger text-center">Error al cargar el usuario: {error.message}</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Editar Usuario</h5>
        </div>
        <div className="card-body">
          {errors.general && <div className="alert alert-danger">{errors.general}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                required
              />
              <label htmlFor="firstName">Nombre</label>
              {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                required
              />
              <label htmlFor="lastName">Apellido</label>
              {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
            </div>

            <div className="form-floating mb-3">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                required
              />
              <label htmlFor="email">Email</label>
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            <div className="form-floating mb-3">
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-control"
              />
              <label htmlFor="phone">Teléfono</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="form-control"
              />
              <label htmlFor="address">Dirección</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="text"
                id="postalCode"
                name="postalCode"
                value={formData.postalCode}
                onChange={handleChange}
                className="form-control"
              />
              <label htmlFor="postalCode">Código Postal</label>
            </div>

            <div className="mb-3">
              <label htmlFor="locality" className="form-label">Localidad</label>
              <input
                type="text"
                id="locality"
                name="locality"
                value={formData.locality.id}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="d-flex gap-2">
              <button type="submit" disabled={isSubmitting} className="btn btn-success w-50">
                {isSubmitting ? "Guardando..." : "Guardar Cambios"} <FaSave className="ms-2" />
              </button>
              <button type="button" className="btn btn-outline-secondary w-50" onClick={() => setShowForm(false)}>
                Cancelar <FaTimesCircle className="ms-2" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UserEdit;
